import {
    CommitteeSearchRequest,
    CommitteeSearchResponse,
    CommitteeGetCommitteeRequest,
    CommitteeGetCommitteeResponse,
    CommitteeCreateCommitteesRequest,
    CommitteeCreateCommitteesResponse,
    CommitteeUpdateCommitteesRequest,
    CommitteeUpdateCommitteesResponse,
    CommitteeDeleteCommitteesRequest,
    CommitteeDeleteCommitteesResponse,
    CommitteeCreateCommitteeMembersRequest,
    CommitteeCreateCommitteeMembersResponse,
    CommitteeUpdateCommitteeMembersRequest,
    CommitteeUpdateCommitteeMembersResponse,
    CommitteeDeleteCommitteeMembersRequest,
    CommitteeDeleteCommitteeMembersResponse,
    CommitteeGetCommitteeMembersRequest,
    CommitteeGetCommitteeMembersResponse,
    CommitteeGetCandidateMembersRequest,
    CommitteeGetCandidateMembersResponse
} from '../../../model';
import {CrudService} from "../../core/common/crud-service";

export class CommitteeService extends CrudService {

    protected readonly basePath = '/api/committee';

    async search(request: CommitteeSearchRequest): Promise<CommitteeSearchResponse[] | null> {
        return this.customPost<CommitteeSearchRequest, CommitteeSearchResponse[]>(
            'search',
            request
        );
    }

    /**
     * Get committee by ID or name
     */
    async getCommittee(request: CommitteeGetCommitteeRequest): Promise<CommitteeGetCommitteeResponse | null> {
        return this.customPost<CommitteeGetCommitteeRequest, CommitteeGetCommitteeResponse>(
            'getCommittee',
            request
        );
    }

    /**
     * Create one or more committees
     */
    async create(
        request: CommitteeCreateCommitteesRequest
    ): Promise<CommitteeCreateCommitteesResponse | null> {
        return this.customPost<CommitteeCreateCommitteesRequest, CommitteeCreateCommitteesResponse>(
            'create',
            request
        );
    }

    /**
     * Update one or more committees
     */
    async update(
        request: CommitteeUpdateCommitteesRequest
    ): Promise<CommitteeUpdateCommitteesResponse | null> {
        return this.customPost<CommitteeUpdateCommitteesRequest, CommitteeUpdateCommitteesResponse>(
            'update',
            request
        );
    }

    /**
     * Delete one or more committees
     */
    async delete(
        request: CommitteeDeleteCommitteesRequest
    ): Promise<CommitteeDeleteCommitteesResponse | null> {
        return this.customPost<CommitteeDeleteCommitteesRequest, CommitteeDeleteCommitteesResponse>(
            'delete',
            request
        );
    }

    /**
     * Create one or more committee members
     */
    async createCommitteeMembers(
        request: CommitteeCreateCommitteeMembersRequest
    ): Promise<CommitteeCreateCommitteeMembersResponse | null> {
        return this.customPost<CommitteeCreateCommitteeMembersRequest, CommitteeCreateCommitteeMembersResponse>(
            'createCommitteeMembers',
            request
        );
    }

    /**
     * Update one or more committee members
     */
    async updateCommitteeMembers(
        request: CommitteeUpdateCommitteeMembersRequest
    ): Promise<CommitteeUpdateCommitteeMembersResponse | null> {
        return this.customPost<CommitteeUpdateCommitteeMembersRequest, CommitteeUpdateCommitteeMembersResponse>(
            'updateCommitteeMembers',
            request
        );
    }

    /**
     * Delete one or more committee members
     */
    async deleteCommitteeMembers(
        request: CommitteeDeleteCommitteeMembersRequest
    ): Promise<CommitteeDeleteCommitteeMembersResponse | null> {
        return this.customPost<CommitteeDeleteCommitteeMembersRequest, CommitteeDeleteCommitteeMembersResponse>(
            'deleteCommitteeMembers',
            request
        );
    }

    /**
     * Get committee members for a specific committee
     */
    async getCommitteeMembers(
        request: CommitteeGetCommitteeMembersRequest
    ): Promise<CommitteeGetCommitteeMembersResponse[] | null> {
        return this.customPost<CommitteeGetCommitteeMembersRequest, CommitteeGetCommitteeMembersResponse[]>(
            'getCommitteeMembers',
            request
        );
    }

    /**
     * Get candidate members that match specific criteria
     */
    async getCandidateMembers(
        request: CommitteeGetCandidateMembersRequest
    ): Promise<CommitteeGetCandidateMembersResponse[] | null> {
        return this.customPost<CommitteeGetCandidateMembersRequest, CommitteeGetCandidateMembersResponse[]>(
            'getCandidateMembers',
            request
        );
    }
}

// Export a singleton instance
export const committeeService = new CommitteeService();
